/** Worklet loaders and the typed messages to the engine and ambience processors (see engine-worklet.ts, ambience-worklet.ts). */
import engineUrl from './engine-worklet.ts?worker&url';
import ambienceUrl from './ambience-worklet.ts?worker&url';
import type { VoiceParams } from './engine-dsp.ts';
import type { AmbienceParams } from './ambience-dsp.ts';

export interface EngineNodeLike {
  port: { postMessage(msg: unknown): void };
  connect(dest: unknown): unknown;
  disconnect(): void;
}

export async function createEngineNode(ctx: BaseAudioContext): Promise<AudioWorkletNode> {
  await ctx.audioWorklet.addModule(engineUrl);
  return new AudioWorkletNode(ctx, 'undercut-engine', { numberOfInputs: 0, numberOfOutputs: 1, outputChannelCount: [2] });
}

export async function createAmbienceNode(ctx: BaseAudioContext): Promise<AudioWorkletNode> {
  await ctx.audioWorklet.addModule(ambienceUrl);
  return new AudioWorkletNode(ctx, 'undercut-ambience', { numberOfInputs: 0, numberOfOutputs: 1, outputChannelCount: [2] });
}

export function postParams(node: EngineNodeLike, raceT: number, voices: VoiceParams[], at?: number): void {
  node.port.postMessage({ type: 'params', ...(at === undefined ? {} : { at }), raceT, voices });
}

export function postAmbience(node: EngineNodeLike, p: AmbienceParams, at?: number): void {
  node.port.postMessage({ type: 'params', ...(at === undefined ? {} : { at }), ...p });
}

export function postSeed(node: EngineNodeLike, seed: number): void {
  node.port.postMessage({ type: 'seed', seed });
}
